var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfiniteD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2125_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2125_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1893 37C19.6893 37 37.1893 19 37.1893 17C37.1893 19 54.6893 37 57.1893 37C54.6893 37 37.1893 55 37.1893 57C37.1893 55 19.6893 37 17.1893 37Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.808 143C125.587 143 117.117 150.6 112 156.91C106.883 150.6 98.4125 143 87.1917 143C80.5104 143 74.1028 145.634 69.3785 150.322C64.6541 155.011 62 161.37 62 168C62 174.63 64.6541 180.989 69.3785 185.678C74.1028 190.366 80.5104 193 87.1917 193C98.4125 193 106.883 185.4 112 179.09C117.117 185.4 125.587 193 136.808 193C143.49 193 149.897 190.366 154.622 185.678C159.346 180.989 162 174.63 162 168C162 161.37 159.346 155.011 154.622 150.322C149.897 145.634 143.49 143 136.808 143ZM87.1917 180.595C83.8256 180.595 80.5975 179.268 78.2173 176.906C75.8372 174.544 74.5 171.34 74.5 168C74.5 164.66 75.8372 161.456 78.2173 159.094C80.5975 156.732 83.8256 155.405 87.1917 155.405C94.7583 155.405 101.387 162.935 104.746 168C101.387 173.065 94.7583 180.595 87.1917 180.595ZM136.808 180.595C129.242 180.595 122.612 173.065 119.254 168C122.612 162.935 129.254 155.405 136.808 155.405C140.174 155.405 143.403 156.732 145.783 159.094C148.163 161.456 149.5 164.66 149.5 168C149.5 171.34 148.163 174.544 145.783 176.906C143.403 179.268 140.174 180.595 136.808 180.595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2125_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.189 299C168.689 299 186.189 281 186.189 279C186.189 281 203.689 299 206.189 299C203.689 299 186.189 317 186.189 319C186.189 317 168.689 299 166.189 299Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2125_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2125_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2125_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(166 279)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiniteD);
export default __webpack_public_path__ + "static/media/InfiniteD.e8097b3b1a13ec9bd19e690f58dd86e0.svg";
export { ForwardRef as ReactComponent };